import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["scrollable"]

    connect() {
        // Call updateShadow for each .scrollable-table within the scrollableTarget
        this.scrollableTables = this.scrollableTarget.querySelectorAll('.scrollable-table')
        this.scrollableTables.forEach((tableWrapper) => {
            this.updateShadow(tableWrapper)
            tableWrapper.addEventListener('scroll', () => this.updateShadow(tableWrapper))
        })
    }

    updateShadow(tableWrapper) {
        // Assuming `tableWrapper` is the `.scrollable-table` element
        const maxScrollLeft = tableWrapper.scrollWidth - tableWrapper.clientWidth;
        const atLeftEdge = tableWrapper.scrollLeft <= 0;
        const atRightEdge = tableWrapper.scrollLeft >= maxScrollLeft;

        // Get the wrapper element
        const wrapper = tableWrapper.closest('.scrollable-table-wrapper');

        // Add 'shadow-left' class if not at the left edge
        wrapper.classList.toggle('shadow-left', !atLeftEdge);

        // Add 'shadow-right' class if not at the right edge
        wrapper.classList.toggle('shadow-right', !atRightEdge);
    }

}
